import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserInfoService } from './security.service';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly supportedLanguages = ['de-DE', 'en-US', 'nl-NL'];
  private readonly defaultLanguage = 'en-US';

  private currentLanguageSubject = new BehaviorSubject<string>(
    this.defaultLanguage
  );
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(
    private translateService: TranslateService,
    private userInfoService: UserInfoService
  ) {
    // Initialize with default language
    this.translateService.setDefaultLang(this.defaultLanguage);
    this.translateService.use(this.defaultLanguage);
  }

  /**
   * Initialize language from user info
   */
  initializeLanguage(): Observable<string> {
    const userInfo = this.userInfoService.get();
    const activeLanguage = userInfo.activeLanguage;

    if (activeLanguage && this.supportedLanguages.includes(activeLanguage)) {
      this.setLanguage(activeLanguage);
      return of(activeLanguage);
    } else {
      console.warn(
        `Unsupported language: ${activeLanguage}. Using default: ${this.defaultLanguage}`
      );
      this.setLanguage(this.defaultLanguage);
      return of(this.defaultLanguage);
    }
  }

  /**
   * Set the application language
   */
  setLanguage(language: string): void {
    if (this.supportedLanguages.includes(language)) {
      this.translateService.use(language);
      this.currentLanguageSubject.next(language);
    } else {
      console.warn(
        `Language ${language} is not supported. Using default: ${this.defaultLanguage}`
      );
      this.translateService.use(this.defaultLanguage);
      this.currentLanguageSubject.next(this.defaultLanguage);
    }
  }
}
